// Angular
import { Injectable, Inject } from '@angular/core';
import { Router } from '@angular/router';

// Third party
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';

// Libs
import { APP_CONFIG } from '@libs/configs';
import { AccountsApiService, AccountResponse } from '@libs/customers/accounts';
import { App } from '@libs/types/app-enum';

@UntilDestroy()
@Injectable()
export class NavigationService {
  private accountBaseUrl: string;
  private recruitingBaseUrl: string;
  private campaignDetailUrl: string;
  private campaignListUrl: string;

  constructor(
    private accountsApi: AccountsApiService,
    private router: Router,
    @Inject(APP_CONFIG) private appConfig: any,
  ) {
    if (this.appConfig.app === 'EMPLOYER') {
      this.accountBaseUrl = '/business';
      this.recruitingBaseUrl = 'recruiting';
      this.campaignDetailUrl = '/recruiting/promote/';
      this.campaignListUrl = '/recruiting/promote/';
    } else {
      this.accountsApi.currentAccount$
        .pipe(untilDestroyed(this))
        .subscribe((account: AccountResponse) => {
          if (account) {
            this.accountBaseUrl = `/account/${account.id}`;
          }
        });
      this.campaignDetailUrl = '/recruiting/promote/detail/';
      this.campaignListUrl = '/recruiting/promote/list/';
    }
  }

  /**
   * @function forceUpdateBaseAccountUrlWhenInAdmin overrides the accountBaseUrl when in Admin
   * this is mainly for Admin since currentAccount$ relies on auth to give the accountId which it doesn't have
   */
  forceUpdateBaseAccountUrlWhenInAdmin(accountId: string): void {
    if (this.appConfig.app === App.Admin) {
      this.accountBaseUrl = `/account/${accountId}`;
    }
  }

  goToAccountPages(sub: string, queryParams: object = null): void {
    const url = `/${this.accountBaseUrl}/${sub}`;
    this.router.navigate([url], { queryParams: queryParams });
  }

  goToRecruitingPages(sub: string, queryParams: object): void {
    const url = `/${this.recruitingBaseUrl}/${sub}`;
    this.router.navigate([url], { queryParams: queryParams });
  }

  goToCampaign(id: string, action?: string): void {
    if (action) {
      this.router.navigate([
        `${this.campaignDetailUrl}/${action}/targeting/${id}`,
      ]);
    } else {
      this.router.navigate([`${this.campaignDetailUrl}/${id}`]);
    }
  }

  goToCampaignCollection(accountId: string): void {
    let url: string;

    if (this.appConfig.app === 'EMPLOYER') {
      url = this.campaignListUrl;
    } else {
      url = `/${this.campaignListUrl}/${accountId}/`;
    }

    this.router.navigate([url]);
  }
}
